import React, { useEffect, useState } from "react";
import './Customization.css';
import API from '../API';
import { useAuth0 } from "@auth0/auth0-react";
import LeftArrowButton from './images/left_arrow_button.png';
import RightArrowButton from './images/right_arrow_button.png';
import TutorialPanel from './images/tutorial-panel.png';

const Customization = ({ wallets }) => {
    const itemsPerPage = 16;
    const [assets, setAssets] = useState(null);
    const [accessToken, setAccessToken] = useState("");
    const [assetTypeIndex, setAssetTypeIndex] = useState(0);
    const { isAuthenticated, getAccessTokenSilently, isLoading } = useAuth0();
    const [pageInfo, setPageInfo] = useState({});
    
    useEffect(() => {
        window.setAccessToken = (accessToken2) => {
            setAccessToken(accessToken2);
        };
    }, [accessToken]);

    const toggleLeft = () => {
        if (assetTypeIndex === 0) {
            setAssetTypeIndex(assets.length - 1);
        }
        else {
            setAssetTypeIndex(assetTypeIndex - 1);
        }
    };
    const toggleRight = () => {
        if (assetTypeIndex === assets.length - 1) {
            setAssetTypeIndex(0);
        }
        else {
            setAssetTypeIndex(assetTypeIndex + 1);
        }
    };
    const updateAsset = (asset_type, asset_id) => {
        return (event) => {
            Array.from(document.querySelectorAll(`.${asset_type}-cards .asset-selected`)).forEach(function(el) { 
                el.classList.remove('asset-selected');
            });
            event.target.classList.add('asset-selected');
            API.customizeCharacter(accessToken, {"asset_type": asset_type, "asset_id": asset_id});
        }
    };

    useEffect(() => {
        async function getAssets() {
            if (!accessToken && isAuthenticated) {
                const accessToken = await getAccessTokenSilently({
                    audience: process.env.REACT_APP_AUTH0_AUDIENCE,
                    scope: "ffclient:play",
                });
                setAccessToken(accessToken);
            }
            
            if (accessToken) {
                const response = await API.getFuturebotAssets(accessToken);
                if (response.status !== 200) {
                    console.log("Error getting futurebot assets.");
                    return;
                }
    
                // Process data
                var data = await response.json();
                // Sort
                data.sort((a,b) => a['asset_type'] === 'face_id' ? -1 : b['asset_type'] === 'face_id' ? 1 : a['asset_type'] === 'hat_id' ? -1 : b['asset_type'] === 'hat_id' ? 1 : 0 );
                for(let i = 0; i < data.length; i++) {
                    if (data[i]['asset_type'] === 'face_plate_id') {
                        data[i].values.sort((a,_) => a.id === 'Clear' ? -1 : 0);
                    }
                    if (data[i]['asset_type'] === 'pet_id') {
                        data[i].values.sort((a,_) => a.id === 'NoPet' ? -1 : 0);
                    }
                }
                // Calculate pagination info
                let pageInfoObj = {};
                for(let i = 0; i < data.length; i++) {
                    let page = {
                        numOfPages: Math.trunc(data[i].values.length / itemsPerPage) + 1,
                        currentPageIndex: 0,
                        currentSelectedIndex: 0,
                    };
                    pageInfoObj[data[i]['asset_type']] = page;
                }
                setPageInfo(pageInfoObj);
                setAssets(data);
                setAccessToken(accessToken);
            }
        };
        getAssets();
    }, [getAccessTokenSilently, isAuthenticated, wallets, accessToken]);

    if (isLoading) {
        return <div>Loading ...</div>;
    }

    return assets && (
        <div className="customization-panel">
            <h1 className="customization-title">Customization</h1>
            <div className="faces-toggle-area">
                <button onClick={toggleLeft} className="asset-selector-button"><img alt="Left Arrow" src={LeftArrowButton} /></button>
                <h3 className="asset-selector-title">{assets[assetTypeIndex].name}</h3>
                <button onClick={toggleRight} className="asset-selector-button"><img alt="Right Arrow" src={RightArrowButton} /></button>
            </div>
            { assets.map((asset, typeIndex) => 
                <div key={asset.name}>
                    <div style={{display: assets[assetTypeIndex].name === asset.name ? "grid" : "none"}} className={`cards ${asset.asset_type}-cards`}>
                        {asset.values.map((value, index) => 
                            <button key={value.id} style={{ backgroundImage: "url('" + value.url + "')", display: pageInfo[asset.asset_type].currentPageIndex === Math.trunc(index / itemsPerPage) ? "flex" : "none"}} className="asset-update-button card" onClick={updateAsset(asset.asset_type, value.id)} />
                        )}
                        { pageInfo[asset.asset_type].currentPageIndex === pageInfo[asset.asset_type].numOfPages - 1 && Array(itemsPerPage - Math.trunc(asset.values.length % itemsPerPage)).fill(0).map((_, i) =>
                            <button key={`empty-button-${asset.asset_type}-${i}`} className="asset-update-button card" disabled />
                        )}
                    </div>
                    <div className="pagination-buttons" style={{display: typeIndex === assetTypeIndex ? "flex" : "none"}}>
                        <button className="pagination-button" onClick={() => {
                            let pageInfoObj = Object.assign({}, pageInfo);
                            pageInfoObj[asset.asset_type].currentPageIndex = pageInfoObj[asset.asset_type].currentPageIndex === 0 ? pageInfoObj[asset.asset_type].numOfPages - 1 : pageInfoObj[asset.asset_type].currentPageIndex - 1;
                            setPageInfo(pageInfoObj);
                        }}><img alt="Left Arrow" src={LeftArrowButton} /></button>
                        <button className="pagination-button" onClick={() => {
                            let pageInfoObj = Object.assign({}, pageInfo);
                            pageInfoObj[asset.asset_type].currentPageIndex = pageInfoObj[asset.asset_type].currentPageIndex === pageInfoObj[asset.asset_type].numOfPages - 1 ? 0 : pageInfoObj[asset.asset_type].currentPageIndex + 1;
                            setPageInfo(pageInfoObj);
                        }}><img alt="Right Arrow" src={RightArrowButton} /></button>
                    </div>
                </div>
            )}
            <h1 className="customization-title">Controls</h1>
            <div className="tutorial"><img alt="Tutorial Panel" src={TutorialPanel} /></div>
        </div>
    );
};

export default Customization;
